import React from 'react'
import {useNavigate} from 'react-router-dom'
import axios from 'axios'
import {KTIcon} from '../../helpers'
import {NotificationType} from '../../../types/notificationTypes'
import {useAuth} from '../../../app/modules/auth'
import {ensureBenefitDetail} from '../../../utils/ensureBenefitDetail'
import './NotificationToast.css'

interface NotificationToastProps {
  type: NotificationType
  claimNumber: string
  onClose: () => void
}

/**
 * Custom Toast Notification Component - Compact Dribbble Style
 * Auto-closes after 8 seconds
 */
const NotificationToast: React.FC<NotificationToastProps> = ({type, claimNumber, onClose}) => {
  const navigate = useNavigate()
  const {auth} = useAuth()

  const getMessage = () => {
    return type === 'chat' ? 'New chat message' : 'Status updated'
  }

  const getIcon = () => {
    return type === 'chat' ? 'message-text-2' : 'notification-status'
  }

  const getAccentColor = () => {
    return type === 'chat' ? '#3699ff' : '#7239ea'
  }

  const handleCheck = () => {
    onClose()
    // Delay navigation to allow React to finish processing the toast removal
    // This prevents the "Rendered fewer hooks than expected" error
    setTimeout(async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Provider/GetByClaimNumber/${claimNumber}`
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })

        if (response.data) {
          if (!ensureBenefitDetail(response.data)) return

          const path = response.data?.treatmentType === 'Rawat jalan' 
          ? '/outpatient' 
          : '/inpatient'
          
          navigate(path, {state: {claimDetails: response.data}})
        }
      } catch (error) {
        console.error('Error fetching claim details:', error)
        navigate('/inpatient', {state: {claimNumber}})
      }
    }, 0)
  }

  return (
    <div className='notification-toast'>
      <div className='toast-accent' style={{backgroundColor: getAccentColor()}} />
      <div className='toast-content'>
        <div className='toast-icon-wrapper' style={{backgroundColor: `${getAccentColor()}15`}}>
          <KTIcon
            iconName={getIcon()}
            className={`fs-4 ${type === 'chat' ? 'text-primary' : 'text-info'}`}
          />
        </div>
        <div className='toast-info'>
          <span className='toast-claim'>{claimNumber}</span>
          <span className='toast-message'>{getMessage()}</span>
        </div>
        <div className='toast-actions'>
          <button
            className='toast-btn-check'
            onClick={handleCheck}
            style={{color: getAccentColor()}}
          >
            View
          </button>
          <button className='toast-btn-close' onClick={onClose} aria-label='Close'>
            <KTIcon iconName='cross' className='fs-5' />
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotificationToast
